import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactNotifications } from 'react-notifications-component';
import showNotification from '../component/Notification';
import baseURL from '../component/baseURL';
export default function EditFilter() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();
    const [userid, setUserid] = useState('');
    const [agentkey, setAgentkey] = useState('');
    const [agentID, setAgentID] = useState('');
    const [filterID, setFilterID] = useState('');
    const [filterName, setFilterName] = useState('');
    const [minValue, setMinValue] = useState('');
    const [maxValue, setMaxValue] = useState('');
    const [selectedBedroom, setSelectedBedroom] = useState('');
    const [selectedBathroom, setSelectedBathroom] = useState('');
    const [selectedPropertyType, setSelectedPropertyType] = useState('');

    const [countryName, setCountryName] = useState("");
    const [countryCode, setCountryCode] = useState("");
    const [countryNameArray, setCountryNameArray] = useState([]);
    const [stateName, setStateName] = useState("");
    const [stateNameArray, setStateNameArray] = useState([]);
    const [stateCode, setStateCode] = useState("");
    const [selectedStates, setSelectedStates] = useState([]);
    const [isStateDropdownOpen, setIsStateDropdownOpen] = useState(false);
    const stateDropdownRef = React.useRef(null);
    const [cityName, setCityName] = useState("");
    const [cityNameArray, setCityNameArray] = useState([]);
    const [cityCode, setCityCode] = useState("");
    const [selectedCities, setSelectedCities] = useState([]);
    const [isCityDropdownOpen, setIsCityDropdownOpen] = useState(false);
    const cityDropdownRef = React.useRef(null);



    useEffect(() => {
        const userID = localStorage.getItem('userID');
        setUserid(userID);
        const agentkey = localStorage.getItem('agentKey');
        setAgentkey(agentkey);
        const agentid = localStorage.getItem('agentID');
        setAgentID(agentid);

        // Get filter data from navigation state
        const filterData = location.state?.filterData;
        console.log("filterData", filterData);
        if (filterData) {
            setFilterID(filterData.filter_id || '');
            setFilterName(filterData.filter_name || '');
            setMinValue(filterData.min_price || '');
            setMaxValue(filterData.max_price || '');
            setSelectedBedroom(filterData.bedroom || '');
            setSelectedBathroom(filterData.bathroom || '');

            // Set property type and log for debugging
            const propertyTypeValue = filterData.property_type || '';
            console.log("Property Type from API:", propertyTypeValue);
            console.log("Property Type trimmed:", propertyTypeValue.trim());
            setSelectedPropertyType(propertyTypeValue.trim());


            // Set location data
            const countryCodeValue = filterData.country || '';
            const stateCodeValue = filterData.region || '';
            const cityCodeValue = filterData.city || '';

            setCountryCode(countryCodeValue);
            setCountryName(filterData.country_name || '');

            // Handle multiple states (comma-separated)
            if (stateCodeValue) {
                const statesArray = stateCodeValue.split(',').map(s => s.trim()).filter(s => s);
                setSelectedStates(statesArray);
                setStateCode(statesArray[0] || '');
            } else {
                setSelectedStates([]);
                setStateCode('');
            }
            setStateName(filterData.region_name || '');

            // Handle multiple cities (comma-separated)
            if (cityCodeValue) {
                const citiesArray = cityCodeValue.split(',').map(c => c.trim()).filter(c => c);
                setSelectedCities(citiesArray);
                setCityCode(citiesArray[0] || '');
            } else {
                setSelectedCities([]);
                setCityCode('');
            }
            setCityName(filterData.cities || '');

            // Fetch country list first, then state and city
            fetchCountryAPI().then(() => {
                // After countries are loaded, fetch states if country code exists
                if (countryCodeValue) {
                    // Reduce timeout for faster loading
                    setTimeout(() => {
                        fetchStateAPI(countryCodeValue).then(() => {
                            // After states are loaded, fetch cities if state codes exist
                            if (stateCodeValue) {
                                const statesArray = stateCodeValue.split(',').map(s => s.trim()).filter(s => s);
                                if (statesArray.length > 0) {
                                    // Fetch cities immediately without extra timeout
                                    fetchCityAPI(statesArray.join(','), countryCodeValue).then(() => {
                                        // After cities are loaded, set selected cities if cityCodeValue exists
                                        if (cityCodeValue) {
                                            const citiesArray = cityCodeValue.split(',').map(c => c.trim()).filter(c => c);
                                            setSelectedCities(citiesArray);
                                            console.log("City data loaded, selectedCities:", citiesArray);
                                        }
                                    });
                                }
                            }
                        });
                    }, 50); // Reduced from 200ms to 50ms
                }
            });
        } else {
            fetchCountryAPI();
        }
    }, []);

    // Close state dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (stateDropdownRef.current && !stateDropdownRef.current.contains(event.target)) {
                setIsStateDropdownOpen(false);
            }
        };

        if (isStateDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isStateDropdownOpen]);

    // Close city dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (cityDropdownRef.current && !cityDropdownRef.current.contains(event.target)) {
                setIsCityDropdownOpen(false);
            }
        };

        if (isCityDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isCityDropdownOpen]);

    function updateFilterApi() {
        // const { navigate } = this.props.navigation;
        if (countryName != '' && filterName != '') {
            let formdata = new FormData();
            formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
            formdata.append("user_id", userid);
            formdata.append("filter_id", filterID);
            formdata.append("filter_type", 'pool');
            formdata.append("filter_name", filterName);
            formdata.append("country", countryCode);
            // Send multiple states as comma-separated string, or single state if only one selected
            const regionValue = selectedStates.length > 0 ? selectedStates.join(',') : stateCode;
            formdata.append("region", regionValue);
            // Send multiple cities as comma-separated string, or single city if only one selected
            const cityValue = selectedCities.length > 0 ? selectedCities.join(',') : cityCode;
            formdata.append("city", cityValue);
            formdata.append("bedroom", selectedBedroom);
            formdata.append("bathroom", selectedBathroom);
            formdata.append("min_price", minValue);
            formdata.append("max_price", maxValue);
            formdata.append("property_type", selectedPropertyType);
            formdata.append("agent_id", agentID);
            fetch(baseURL.URL + '/consumer_portfolio/filter_update', { method: 'POST', body: formdata })
                .then((response) => response.json())
                .then((responseJson) => {
                    console.log(responseJson);
                    showNotification('Success', 'Filter updated successfully', 'success');
                    setTimeout(() => {
                        navigate('/filter')
                    }, 1000);

                })
                .catch((error) => {
                    console.error(error);
                    showNotification('Error', 'Something went wrong', 'danger');
                });
        }
    }


    // Handle input changes for form data
    const handleInputChange = (field, value) => {
        switch (field) {
            case 'country':
                setCountryName(value);
                break;
            case 'state':
                setStateName(value);
                break;
            case 'city':
                setCityName(value);
                break;
            default:
                break;
        }
    };

    async function fetchCountryAPI() {
        console.log('Fetching countries...');
        try {
            const response = await fetch(baseURL.URL + '/address/country', { method: 'POST' });
            const responseJson = await response.json();
            console.log("Countries loaded:", responseJson.response?.countries);
            setCountryNameArray(responseJson.response?.countries || []);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    }



    async function fetchStateAPI(cCode) {
        console.log("Fetching states for country code:", cCode);
        if (!cCode) {
            return [];
        }

        try {
            let formdata = new FormData();
            formdata.append("country_code", cCode);
            const response = await fetch(baseURL.URL + '/address/state', { method: 'POST', body: formdata });
            const responseJson = await response.json();

            console.log("State API Response:", responseJson);
            // The response is directly an array
            if (responseJson.response && Array.isArray(responseJson.response)) {
                // Clean up region_name (remove \r if present)
                const result = responseJson.response.map((state) => ({
                    ...state,
                    region_name: state.region_name ? state.region_name.replace(/\r/g, '').trim() : state.region_name
                }));
                console.log("States loaded:", result);
                setStateNameArray(result);
                return result;
            } else {
                console.error("Unexpected response format:", responseJson);
                setStateNameArray([]);
                return [];
            }
        } catch (error) {
            console.error('Error fetching states:', error);
            setStateNameArray([]);
            return [];
        }
    }



    async function fetchCityAPI(selected_states_id, country_code = null) {
        const countryCodeToUse = country_code || countryCode;
        console.log("Fetching cities for state_id:", selected_states_id, "country_code:", countryCodeToUse);

        if (!selected_states_id || !countryCodeToUse) {
            return [];
        }

        try {
            let formdata = new FormData();
            formdata.append("country_code", countryCodeToUse);
            formdata.append("state_id", selected_states_id);
            const response = await fetch(baseURL.URL + '/address/city', { method: 'POST', body: formdata });
            const responseJson = await response.json();

            console.log("City API Response:", responseJson);
            if (responseJson.response && Array.isArray(responseJson.response)) {
                // Clean up city_name (remove \r if present)
                const result = responseJson.response.map((city) => ({
                    ...city,
                    city_name: city.city_name ? city.city_name.replace(/\r/g, '').trim() : city.city_name
                }));
                console.log("Cities loaded:", result);
                setCityNameArray(result);
                return result;
            } else {
                console.error("Unexpected response format:", responseJson);
                setCityNameArray([]);
                return [];
            }
        } catch (error) {
            console.error('Error fetching cities:', error);
            setCityNameArray([]);
            return [];
        }
    }

    const normalizeList = (payload) => {
        if (Array.isArray(payload)) {
            return payload;
        }
        if (payload && typeof payload === 'object') {
            return Object.values(payload);
        }
        return [];
    };

    // function clearAll() {
    //     setFilterName('');
    //     setCountryCode('');
    //     setStateCode('');
    //     setCityCode('');
    //     setSelectedStates([]);
    //     setSelectedCities([]);
    //     setMinValue('');
    //     setMaxValue('');
    //     setSelectedBedroom('');
    //     setSelectedBathroom('');
    //     setSelectedPropertyType('');
    //     setStateNameArray([]);
    //     setCityNameArray([]);
    //     setStateName('');
    //     setCityName('');
    //     setCountryName('');
    // }


    return (
        <>
            <ReactNotifications />
            <main className="main-content">
                <div className="container">
                    <div className="filter-page-layout">
                        <section className="filter-section">
                            <div className="add-filter-header flex justify-start items-center">
                                <button className="mobile-filter-back" aria-label="Back" onClick={() => navigate('/filter')}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M12.5 15L7.5 10L12.5 5" stroke="#0E0E0E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                                <h2 className="filter-title mb-6">{t('editFilter')}</h2>
                            </div>
                            {/* <!-- Filter Panel - Right Side --> */}
                            <div className="filter-panel" id="filterPanel">

                                <div className="panel-section">
                                    <h3 className="panel-heading">{t('portfolioFilter')}</h3>
                                    <input type="text" className="filter-input" placeholder="Enter Filter Name" value={filterName} onChange={(e) => setFilterName(e.target.value)} />
                                </div>



                                <div className="panel-section">
                                    <h3 className="panel-heading">{t('location')}</h3>
                                    <div className="dropdown-group">
                                        <select
                                            name="countrys"
                                            id="countrys"
                                            className="dark_text form-control"
                                            value={countryCode || ''}
                                            onChange={(e) => {
                                                const selectedCode = e.target.value;
                                                setCountryCode(selectedCode);

                                                const selectedCountry = countryNameArray.find(
                                                    (country) => country.code === selectedCode
                                                );

                                                if (selectedCountry) {
                                                    setCountryName(selectedCountry.name);
                                                    console.log("Selected Country Name:", selectedCountry.name);
                                                }

                                                // Reset state and city when country changes
                                                setStateNameArray([]);
                                                setStateName('');
                                                setStateCode('');
                                                setSelectedStates([]);
                                                setCityNameArray([]);
                                                setCityName('');
                                                setCityCode('');
                                                setSelectedCities([]);

                                                // Call the API immediately
                                                fetchStateAPI(e.target.value);
                                                console.log("=========== state api call")
                                            }}
                                        >
                                            <option value="">Select Country</option>
                                            {/* Render country options */}
                                            {countryNameArray.map((country) => (
                                                <option key={country.code} value={country.code}>
                                                    {country.name}
                                                </option>
                                            ))}
                                        </select>

                                        <div className="state-dropdown-wrapper" ref={stateDropdownRef} style={{ position: 'relative', width: '100%' }}>
                                            <div
                                                className="state-dropdown-trigger dark_text form-control"
                                                onClick={() => setIsStateDropdownOpen(!isStateDropdownOpen)}
                                                style={{
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    minHeight: '38px',
                                                    padding: '8px 12px',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '0.375rem',
                                                    backgroundColor: '#fff'
                                                }}
                                            >
                                                <div style={{ flex: 1, display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                    {selectedStates.length > 0 ? (
                                                        selectedStates.map((stateCode) => {
                                                            const state = stateNameArray.find(s => s.region_code === stateCode);
                                                            return state ? (
                                                                <span
                                                                    key={stateCode}
                                                                    style={{
                                                                        display: 'inline-block',
                                                                        padding: '2px 8px',
                                                                        backgroundColor: '#007bff',
                                                                        color: '#fff',
                                                                        borderRadius: '12px',
                                                                        fontSize: '12px',
                                                                        marginRight: '0px'
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        const updatedStates = selectedStates.filter(code => code !== stateCode);
                                                                        setSelectedStates(updatedStates);
                                                                        if (updatedStates.length > 0) {
                                                                            setStateCode(updatedStates[0]);
                                                                        } else {
                                                                            setStateCode('');
                                                                        }
                                                                        setCityNameArray([]);
                                                                        setCityName('');
                                                                        setCityCode('');
                                                                        setSelectedCities([]);

                                                                        // Fetch cities for remaining states
                                                                        if (updatedStates.length > 0) {
                                                                            setTimeout(() => {
                                                                                fetchCityAPI(updatedStates.join(','));
                                                                            }, 100);
                                                                        }
                                                                    }}
                                                                >
                                                                    {state.region_name} ×
                                                                </span>
                                                            ) : null;
                                                        })
                                                    ) : (
                                                        <span class="placeholder-text" style={{ color: '#999' }}>Select State</span>
                                                    )}
                                                </div>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 16 16"
                                                    fill="none"
                                                    style={{
                                                        transform: isStateDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                                        transition: 'transform 0.2s'
                                                    }}
                                                >
                                                    <path d="M4 6L8 10L12 6" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>

                                            {isStateDropdownOpen && (
                                                <div
                                                    className="state-dropdown-menu"
                                                    style={{
                                                        position: 'absolute',
                                                        top: '100%',
                                                        left: 0,
                                                        right: 0,
                                                        zIndex: 1000,
                                                        backgroundColor: '#fff',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '0.375rem',
                                                        marginTop: '4px',
                                                        maxHeight: '200px',
                                                        overflowY: 'auto',
                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                                    }}
                                                >
                                                    {stateNameArray.length > 0 ? (
                                                        <ul style={{ listStyle: 'none', padding: '8px', margin: 0 }}>
                                                            {stateNameArray.map((state) => (
                                                                <li key={state.region_code} style={{ marginBottom: '4px' }}>
                                                                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '4px' }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            value={state.region_code}
                                                                            checked={selectedStates.includes(state.region_code)}
                                                                            onChange={(e) => {
                                                                                const stateCodeValue = state.region_code;
                                                                                let updatedStates;

                                                                                if (e.target.checked) {
                                                                                    updatedStates = [...selectedStates, stateCodeValue];
                                                                                } else {
                                                                                    updatedStates = selectedStates.filter(code => code !== stateCodeValue);
                                                                                }

                                                                                setSelectedStates(updatedStates);

                                                                                if (updatedStates.length > 0) {
                                                                                    setStateCode(updatedStates[0]);
                                                                                } else {
                                                                                    setStateCode('');
                                                                                }

                                                                                setCityNameArray([]);
                                                                                setCityName('');
                                                                                setCityCode('');
                                                                                setSelectedCities([]);

                                                                                // Fetch cities for all selected states immediately
                                                                                if (updatedStates.length > 0) {
                                                                                    fetchCityAPI(updatedStates.join(','));
                                                                                }
                                                                            }}
                                                                            style={{ marginRight: '8px', cursor: 'pointer' }}
                                                                        />
                                                                        <span className="dark_text">{state.region_name}</span>
                                                                    </label>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        <p className="dark_text" style={{ margin: 0, padding: '10px', textAlign: 'center' }}>
                                                            Select a country first
                                                        </p>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className="city-dropdown-wrapper" ref={cityDropdownRef} style={{ position: 'relative', width: '100%' }}>
                                            <div
                                                className="city-dropdown-trigger dark_text form-control"
                                                onClick={() => setIsCityDropdownOpen(!isCityDropdownOpen)}
                                                style={{
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    minHeight: '38px',
                                                    padding: '8px 12px',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '4px',
                                                    backgroundColor: '#fff'
                                                }}
                                            >
                                                <div style={{ flex: 1, display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                    {selectedCities.length > 0 ? (
                                                        selectedCities.map((cityId) => {
                                                            const city = cityNameArray.find(c => String(c.city_id) === String(cityId));
                                                            return city ? (
                                                                <span
                                                                    key={cityId}
                                                                    style={{
                                                                        display: 'inline-block',
                                                                        padding: '2px 8px',
                                                                        backgroundColor: '#007bff',
                                                                        color: '#fff',
                                                                        borderRadius: '12px',
                                                                        fontSize: '12px',
                                                                        marginRight: '0px'
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        const updatedCities = selectedCities.filter(id => String(id) !== String(cityId));
                                                                        setSelectedCities(updatedCities);
                                                                        if (updatedCities.length > 0) {
                                                                            setCityCode(updatedCities[0]);
                                                                        } else {
                                                                            setCityCode('');
                                                                        }
                                                                    }}
                                                                >
                                                                    {city.city_name} ×
                                                                </span>
                                                            ) : null;
                                                        })
                                                    ) : (
                                                        <span class="placeholder-text" style={{ color: '#999' }}>Select City</span>
                                                    )}
                                                </div>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 16 16"
                                                    fill="none"
                                                    style={{
                                                        transform: isCityDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                                        transition: 'transform 0.2s'
                                                    }}
                                                >
                                                    <path d="M4 6L8 10L12 6" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>

                                            {isCityDropdownOpen && (
                                                <div
                                                    className="city-dropdown-menu"
                                                    style={{
                                                        position: 'absolute',
                                                        top: '100%',
                                                        left: 0,
                                                        right: 0,
                                                        zIndex: 1000,
                                                        backgroundColor: '#fff',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '0.375rem',
                                                        marginTop: '4px',
                                                        maxHeight: '200px',
                                                        overflowY: 'auto',
                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                                    }}
                                                >
                                                    {cityNameArray.length > 0 ? (
                                                        <ul style={{ listStyle: 'none', padding: '8px', margin: 0 }}>
                                                            {cityNameArray.map((city) => (
                                                                <li key={city.city_id} style={{ marginBottom: '4px' }}>
                                                                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '4px' }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            value={city.city_id}
                                                                            checked={selectedCities.some(id => String(id) === String(city.city_id))}
                                                                            onChange={(e) => {
                                                                                const cityIdValue = city.city_id;
                                                                                let updatedCities;

                                                                                if (e.target.checked) {
                                                                                    updatedCities = [...selectedCities, String(cityIdValue)];
                                                                                } else {
                                                                                    updatedCities = selectedCities.filter(id => String(id) !== String(cityIdValue));
                                                                                }

                                                                                setSelectedCities(updatedCities);

                                                                                if (updatedCities.length > 0) {
                                                                                    setCityCode(updatedCities[0]);
                                                                                } else {
                                                                                    setCityCode('');
                                                                                }

                                                                                if (updatedCities.length > 0) {
                                                                                    const firstCity = cityNameArray.find(c => String(c.city_id) === String(updatedCities[0]));
                                                                                    if (firstCity) {
                                                                                        setCityName(firstCity.city_name);
                                                                                    }
                                                                                } else {
                                                                                    setCityName('');
                                                                                }
                                                                            }}
                                                                            style={{ marginRight: '8px', cursor: 'pointer' }}
                                                                        />
                                                                        <span className="dark_text">{city.city_name}</span>
                                                                    </label>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        <p className="dark_text" style={{ margin: 0, padding: '10px', textAlign: 'center' }}>
                                                            {selectedStates.length > 0 ? 'No cities found' : 'Select state first'}
                                                        </p>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="panel-section">
                                    <h3 className="panel-heading">{t('price')}</h3>
                                    <div className="price-inputs">
                                        <input type="text" className="filter-input" placeholder="Min Value" value={minValue} onChange={(e) => setMinValue(e.target.value)} />
                                        <input type="text" className="filter-input" placeholder="Max Value" value={maxValue} onChange={(e) => setMaxValue(e.target.value)} />
                                    </div>
                                </div>

                                <div className="panel-section">
                                    <h3 className="panel-heading">{t('bedrooms')}</h3>
                                    <div className="option-buttons">
                                        <button
                                            type="button"
                                            className={`option-btn ${selectedBedroom === '' || selectedBedroom === 'All' || selectedBedroom === '0' ? 'active' : ''}`}
                                            onClick={() => setSelectedBedroom('')}
                                        >
                                            All
                                        </button>
                                        <button
                                            type="button"
                                            className={`option-btn ${selectedBedroom === '1' ? 'active' : ''}`}
                                            onClick={() => setSelectedBedroom('1')}
                                        >
                                            1
                                        </button>
                                        <button
                                            type="button"
                                            className={`option-btn ${selectedBedroom === '2' ? 'active' : ''}`}
                                            onClick={() => setSelectedBedroom('2')}
                                        >
                                            2
                                        </button>
                                        <button
                                            type="button"
                                            className={`option-btn ${selectedBedroom === '3' ? 'active' : ''}`}
                                            onClick={() => setSelectedBedroom('3')}
                                        >
                                            3
                                        </button>
                                        <button
                                            type="button"
                                            className={`option-btn ${selectedBedroom === '4' ? 'active' : ''}`}
                                            onClick={() => setSelectedBedroom('4')}
                                        >
                                            4
                                        </button>
                                        <button
                                            type="button"
                                            className={`option-btn ${selectedBedroom === '5' ? 'active' : ''}`}
                                            onClick={() => setSelectedBedroom('5')}
                                        >
                                            5
                                        </button>
                                    </div>
                                </div>

                                <div className="panel-section">
                                    <h3 className="panel-heading">{t('bathrooms')}</h3>
                                    <div className="option-buttons">
                                        <button
                                            type="button"
                                            className={`option-btn ${selectedBathroom === '' || selectedBathroom === 'All' || selectedBathroom === '0' ? 'active' : ''}`}
                                            onClick={() => setSelectedBathroom('')}
                                        >
                                            All
                                        </button>
                                        <button
                                            type="button"
                                            className={`option-btn ${selectedBathroom === '1' ? 'active' : ''}`}
                                            onClick={() => setSelectedBathroom('1')}
                                        >
                                            1
                                        </button>
                                        <button
                                            type="button"
                                            className={`option-btn ${selectedBathroom === '2' ? 'active' : ''}`}
                                            onClick={() => setSelectedBathroom('2')}
                                        >
                                            2
                                        </button>
                                        <button
                                            type="button"
                                            className={`option-btn ${selectedBathroom === '3' ? 'active' : ''}`}
                                            onClick={() => setSelectedBathroom('3')}
                                        >
                                            3
                                        </button>
                                        <button
                                            type="button"
                                            className={`option-btn ${selectedBathroom === '4' ? 'active' : ''}`}
                                            onClick={() => setSelectedBathroom('4')}
                                        >
                                            4
                                        </button>
                                        <button
                                            type="button"
                                            className={`option-btn ${selectedBathroom === '5' ? 'active' : ''}`}
                                            onClick={() => setSelectedBathroom('5')}
                                        >
                                            5
                                        </button>
                                    </div>
                                </div>

                                <div className="panel-section">
                                    <h3 className="panel-heading">{t('propertyType')}</h3>
                                    <div className="checkbox-group two-column">
                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                value="ALL"
                                                checked={selectedPropertyType.trim() == 'ALL' || selectedPropertyType.trim() == 'All'}
                                                onChange={(e) => setSelectedPropertyType(e.target.value)}
                                            />
                                            <span>All</span>
                                        </label>
                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                value="SINGLE FAMILY HOME"
                                                checked={selectedPropertyType.trim() == 'SINGLE FAMILY HOME' || selectedPropertyType.trim() == 'Single Family Home'}
                                                onChange={(e) => setSelectedPropertyType(e.target.value)}
                                            />
                                            <span>Single Family Home</span>
                                        </label>
                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                value="LOT / LAND"
                                                checked={selectedPropertyType.trim() == 'LOT / LAND' || selectedPropertyType.trim() == 'Lot / Land'}
                                                onChange={(e) => setSelectedPropertyType(e.target.value)}
                                            />
                                            <span>Lot/Land</span>
                                        </label>
                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                value="CONDO / APARTMENT"
                                                checked={selectedPropertyType.trim() == 'CONDO / APARTMENT' || selectedPropertyType.trim() == 'Condo / Apartment'}
                                                onChange={(e) => setSelectedPropertyType(e.target.value)}
                                            />
                                            <span>Condo/Apartment</span>
                                        </label>
                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                value="MULTI FAMILY HOME"
                                                checked={selectedPropertyType.trim() == 'MULTI FAMILY HOME' || selectedPropertyType.trim() == 'Multi Family Home'}
                                                onChange={(e) => setSelectedPropertyType(e.target.value)}
                                            />
                                            <span>Multi Family Home</span>
                                        </label>
                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                value="MOBILE / MANUFACTORED"
                                                checked={selectedPropertyType.trim() == 'MOBILE / MANUFACTORED' || selectedPropertyType.trim() == 'Mobile / Manufactured'}
                                                onChange={(e) => setSelectedPropertyType(e.target.value)}
                                            />
                                            <span>Mobile/Manufatored</span>
                                        </label>
                                        <label className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                value="COMMERCIAL"
                                                checked={selectedPropertyType.trim() == 'COMMERCIAL' || selectedPropertyType.trim() == 'Commercial'}
                                                onChange={(e) => setSelectedPropertyType(e.target.value)}
                                            />
                                            <span>Commercial</span>
                                        </label>
                                    </div>
                                </div>

                                {/* <div className="panel-section">
                                    <h3 className="panel-heading">Garage</h3>
                                    <div className="option-buttons">
                                        <button className="option-btn active">All</button>
                                        <button className="option-btn">1</button>
                                        <button className="option-btn">2</button>
                                        <button className="option-btn">3</button>
                                        <button className="option-btn">4</button>
                                        <button className="option-btn">5</button>
                                    </div>
                                </div> */}

                                <div className="addFilter-panel-actions flex justify-end gap-3">
                                    <button className="btn-clear" onClick={() => navigate('/filter')}>{t('cancel')}</button>
                                    <button className="btn-apply" onClick={() => updateFilterApi()}>{t('apply')}</button>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </main>
        </>

    );
}